import { Action, ApplicationState } from "features/Permission/types";
import axiosInstance from "../../../config/axiosConfig";
import { transformFormDataDataForPost } from "./applicationServiceUtilities";

export const applicationService = {
  getAllSummaries: async () => {
    try {
      const response = await axiosInstance.get(`/application/summary`);
      return response.data;
    } catch (error) {
      console.error("Error fetching application summaries:", error);
      throw error;
    }
  },

  getApplicationById: async (applicationId: string) => {
    try {
      const response = await axiosInstance.get(`/application`, {
        params: { applicationId },
      });

      if (response.data && response.data.membershipDetails && response.data.membershipDetails.id) {
        response.data.membershipDetails["memberId"] = response.data.membershipDetails.id;
      }

      return response.data;
    } catch (error) {
      console.error(
        `Error fetching application with ID ${applicationId}:`,
        error
      );
      throw error;
    }
  },

  getSummaryByLeadId: async (leadId: string) => {
    try {
      const response = await axiosInstance.get(`/application/summary`, {
        params: { leadId },
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching summary for lead ID ${leadId}:`, error);
      throw error;
    }
  },

  performAction: async (
    applicationFormData: object,
    actionType: string,
    leadId?: string
  ) => {
    let formattedData = applicationFormData;
    if (
      actionType !== Action.SOFT_APPROVE &&
      actionType !== Action.REQUEST_EDIT_APPLICATION &&
      actionType !== Action.REJECT_APPLICATION &&
      actionType !== Action.VERIFICATION_COMPLETE
    ) {
      // for creating and updating applications, we need to format the data
      formattedData = await transformFormDataDataForPost(applicationFormData);
    }

    // Explicitly remove id for CREATE_APPLICATION action to ensure it's not sent in payload
    if (actionType === Action.CREATE_APPLICATION) {
      const data = formattedData as any;
      if (data.id) {
        delete data.id;
      }
    }

    // Log the final payload for debugging
    console.log("Final API payload:", {
      actionType,
      application: {
        leadId,
        ...formattedData,
      }
    });

    try {
      const response = await axiosInstance.post(`/action`, {
        actionType,
        application: {
          leadId,
          ...formattedData,
        },
      });

      return response;
    } catch (error) {
      console.error("Error performing action on application:", error);
      throw error;
    }
  },
};
